






























import VueOptions from '@utils/VueOptions'
import WizardNavbar from '@ui/VenueWizard/VenueNavbar'
import WizardNavigation from '@ui/VenueWizard/WizardNavigation'

settings =
  name: 'InventoryCreateStep'

  resources:
    new_space:
      resourceName: 'space'
      slug: 'suppliers/:wizard.supplierId/spaces/new'

  vue:
    props: ['wizard', 'step']

    components: {
      WizardNavbar,
      WizardNavigation,
    }

    computed:
      space: ->
        @prime?.new_space

      imagesForSamplingActivation: ->
        image = @imageFor 'spaces', 'activation-example-sampling-1.png'
        [image]

      imagesForOnsiteSpaceActivation: ->
        image = @imageFor 'spaces', 'activation-example-onsite-space-1.jpg'
        [image]

    methods:
      hiSelectProductSamplingSpace: ->
        payload =
          space:
            type: 'product_sampling'
            segment: 'Product Placement'
            size: null
            price_in_cents: null
        @triggerResource 'new_space', 'create_space', payload

      hiSelectOnsiteSpace: ->
        payload =
          space:
            type: 'onsite_space'
            segment: 'Onsite'
            size: '10x10'
            price_in_cents: 50000
        @triggerResource 'new_space', 'create_space', payload

      onNewSpaceCreateSpace: (data, space) ->
        stepName = 'sampling-space-edit' if space.type is 'product_sampling'
        stepName ||= 'onsite-space-edit'
        # @wizard.bindSpacesToCreative [space]
        @wizard.navToStepName stepName
        @$router.replace { query: { ...@$route.query, spaceId: space.id } }

export default VueOptions.vue settings
